import FormElement from './form-element.js';

class ButtonGroups extends FormElement {
	#container;
	#elements = {};

	constructor(container) {
		super();

		if (container instanceof jQuery) {
			container = container[0];
		}

		this.#container = container;

		this.#init();
	}

	#init() {
		const btnGroups = Array.from(this.#container.querySelectorAll('.btn-group[data-name]'));

		for (const el of btnGroups) {
			const name = el.dataset.name;

			super.store(name, el.querySelector(':checked').value);

			$(el).on('change', e => {
				this.set(name, el.querySelector(':checked').value);
			});

			this.#elements[ name ] = el;
		}
	}

	set(name, value, ... args) {
		return this.#handleUpdate(name, value, true, ... args);
	}

	update(name, value) {
		return this.#handleUpdate(name, value, false);
	}

	reset(name = null) {
		if (!name) {
			for (const key of Object.keys(this.#elements)) {
				this.reset(key);
			}
			return;
		}

		return this.update(name, this.#elements[ name ].dataset.default);
	}

	#handleUpdate(name, value, callback = true, ... args) {
		const el = this.#elements[ name ];

		const changed = value !== this.get(name);

		super.store(name, value);

		$(el.querySelector(`[value="${value}"]`).closest('.btn')).button('toggle');

		super.runCallback(name, 'update', ... args);

		if (callback) {
			super.runCallback(name, 'set', ... args);
		}

		return changed;
	}
}

function init(container) {
	return new ButtonGroups(container);
}

export default { init };
